import * as UserPasswordAction from "../user/UserPasswordAction";
import * as UserRegistrationAction from "../user/UserRegistrationAction";
import * as UserDetailsAction from "../user/UserDetailsAction";
import * as QuotaAction from "../quotas/QuotaAction";
import * as BasketAction from "../basket/BasketAction";
import * as EmailAction from "../emails/EmailAction";

export const ActionsWithoutErrorToast = [
    UserPasswordAction.REQUEST_CHANGE_USER_PASSWORD_FINISHED,
    UserRegistrationAction.REQUEST_REGISTER_USER_FINISHED,
    QuotaAction.REQUEST_USER_QUOTA_FINISHED,
    BasketAction.REQUEST_BASKET_FINISHED,
    UserDetailsAction.REQUEST_USER_DETAILS_FINISHED,
    UserDetailsAction.REQUEST_INIT_USER_FINISHED,
    EmailAction.REQUEST_VERIFY_ADDITIONAL_EMAIL_FINISHED
];
